// extracted by mini-css-extract-plugin
export default {"project-section":"ProjectList_project-section__ilr0X","project-section__title":"ProjectList_project-section__title__2Yoeb","projects":"ProjectList_projects__8zQxm"};